import { ListKeymap, listHelpers } from '@tiptap/extension-list';
import {
  isAtResourceRowTitleStart,
  shouldBlockListBackspaceInResourceTable,
  unwrapResourceRowAtTitleStart,
} from './resource_row_paragraph.js';

const { handleBackspace, handleDelete } = listHelpers;

/**
 * List backspace/delete with a guard so liftListItem does not run at the start
 * of a resource-row title (that case is handled by unwrapResourceRowAtTitleStart).
 */
export const PostListKeymap = ListKeymap.extend({
  addKeyboardShortcuts() {
    const { listTypes } = this.options;

    return {
      Delete: ({ editor }) => {
        let handled = false;
        listTypes.forEach(({ itemName }) => {
          if (editor.state.schema.nodes[itemName] === undefined) return;
          if (handleDelete(editor, itemName)) handled = true;
        });
        return handled;
      },
      'Mod-Delete': ({ editor }) => {
        let handled = false;
        listTypes.forEach(({ itemName }) => {
          if (editor.state.schema.nodes[itemName] === undefined) return;
          if (handleDelete(editor, itemName)) handled = true;
        });
        return handled;
      },
      Backspace: ({ editor }) => {
        if (!editor?.state) return false;
        const { $from } = editor.state.selection;
        if (shouldBlockListBackspaceInResourceTable($from)) {
          if (isAtResourceRowTitleStart($from)) {
            unwrapResourceRowAtTitleStart(editor, $from);
          }
          return true;
        }

        let handled = false;
        listTypes.forEach(({ itemName, wrapperNames }) => {
          if (editor.state.schema.nodes[itemName] === undefined) return;
          if (handleBackspace(editor, itemName, wrapperNames)) handled = true;
        });
        return handled;
      },
      'Mod-Backspace': ({ editor }) => {
        if (!editor?.state) return false;
        const { $from } = editor.state.selection;
        if (shouldBlockListBackspaceInResourceTable($from)) {
          if (isAtResourceRowTitleStart($from)) {
            unwrapResourceRowAtTitleStart(editor, $from);
          }
          return true;
        }

        let handled = false;
        listTypes.forEach(({ itemName, wrapperNames }) => {
          if (editor.state.schema.nodes[itemName] === undefined) return;
          if (handleBackspace(editor, itemName, wrapperNames)) handled = true;
        });
        return handled;
      },
    };
  },
});
